// MEDIAS
document.addEventListener('DOMContentLoaded', function () {
	var splideElemMain = document.querySelector('#main-slider');
	var splideElemThumbnails = document.querySelector('#thumbnail-slider');

	// SLIDER PRODUCT
	var main = new Splide(splideElemMain, {
		type: 'fade',
		rewind: true,
		pagination: true,
		arrows: false,
		breakpoints: {
			768: {
				arrows: true,
			},
		},
	});

	var thumbnails = new Splide(splideElemThumbnails, {
		type: 'slide',
		height: 522,
		gap: 4,
		fixedWidth: 45,
		fixedHeight: 45,
		direction: 'ttb',
		isNavigation: true,
		pagination: false,
		arrows: false,
		breakpoints: {
			768: {
				direction: 'ltr',
				fixedHeight: 336,
				fixedWidth: 330,
				pagination: true,
				gap: 10,
				perPage: 1,
				padding: {
					left: 10,
					right: 10,
				},
			},
		},
	});
	main.sync(thumbnails);
	main.mount();
	thumbnails.mount();
});

function mmSlideProduct() {
	var splideElemMain = document.querySelector('#main-slider');
	// SLIDER PRODUCT
	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: 'slide',
			pagination: true,
			arrows: true,
			perPage: 1,
			breakpoints: {
				768: {
					padding: {
						right: 40,
					},
				},
			},
		});
		main.mount();
	}
}

// Dropdown
let collFaq = document.querySelectorAll('.mm-id-faq');
let i;
// Ouvrir par défaut le premier bloc
if (collFaq.length > 0) {
	collFaq[0].classList.add('active');
	const content = collFaq[0].nextElementSibling;
	content.style.maxHeight = content.scrollHeight + 'px';
}
for (i = 0; i < collFaq.length; i++) {
	collFaq[i].addEventListener('click', function () {
		// Fermer tous les autres blocs sauf celui cliqué
		for (let j = 0; j < collFaq.length; j++) {
			if (collFaq[j] !== this && collFaq[j].classList.contains('active')) {
				collFaq[j].classList.remove('active');
				const content = collFaq[j].nextElementSibling;
				content.style.maxHeight = null;
			}
		}
		// Basculer la classe active et ajuster la hauteur du contenu
		this.classList.toggle('active');
		const content = this.nextElementSibling;
		if (content.style.maxHeight) {
			content.style.maxHeight = null;
		} else {
			content.style.maxHeight = content.scrollHeight + 'px';
		}
	});
}

/* Truncate Description */
function mmToggleDescr() {
	let trunDescriptions = document.querySelectorAll(".mm-truncate-descr");
	trunDescriptions.forEach(function (descr) {
		descr.classList.toggle("mm-none");
	});
}

// Pedimeter
// Ouvrir la modale
function mmOpenPedimeter() {
	document.querySelector('.mm-surface-modale').classList.add('mm-modal-is-open');
	document.querySelector('html').classList.add('stop-scrolling');
}
// Fermer la modal
function mmClosePedimeter() {
	document.querySelector('.mm-surface-modale').classList.remove('mm-modal-is-open');
	document.querySelector('html').classList.remove('stop-scrolling');
}

// STICKY CTA DISPLAY ONLY WHEN SCROLL AFTER TRUE CTA
var derniere_position_de_scroll_connue = 0;
var ticking = false;
var CTA = document.querySelector('.sticky-btn');

function mmCtaSticky(position_scroll) {
	if (position_scroll > 900) {
		CTA.classList.add('mm-cta-sticky');
	} else {
		CTA.classList.remove('mm-cta-sticky');
	}
}

window.addEventListener('scroll', function (e) {
	derniere_position_de_scroll_connue = window.scrollY;

	if (!ticking) {
		window.requestAnimationFrame(function () {
			mmCtaSticky(derniere_position_de_scroll_connue);
			ticking = false;
		});
	}

	handleModalePediPosition();
});

function handleModalePediPosition() {
	const modalPedi = document.getElementById('modalePedimetre');
	const header = document.querySelector('.mm-section-header');

	if (modalPedi && header) {
		const headerRect = header.getBoundingClientRect();
		const headerBottom = headerRect.bottom;
		modalPedi.style.top = `${headerBottom}px`;
	}
}

function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll('.mm-update-price');

	priceAll.forEach(function (price) {
		var promoQtty = parseFloat(price.dataset.promoQuantity);
		var unitPrice = parseFloat(price.dataset.value) / 100; // Prix à l'unité en euros
		var totalPrice;

		if (!isNaN(promoQtty) && qtty >= promoQtty) {
			totalPrice = (parseFloat(price.dataset.promoPrice) * qtty) / 100;
		} else {
			totalPrice = unitPrice * qtty;
		}
		var formattedPrice = totalPrice.toFixed(2);
		var euros = Math.floor(totalPrice);
		var cents = Math.round((totalPrice - euros) * 100);
		price.innerHTML = euros + '€' + (cents > 0 ? cents : '00'); // Affichage
	});
}

document.addEventListener('DOMContentLoaded', () => {
	mmSlideProduct();
	handleModalePediPosition();
});

class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest('#product-form');
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			this.variantFetch();
			this.updateCTA();
		}
	}

	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll('.mm-product-variant-checkbox:checked'), (checkbox) => checkbox.value);
		console.log(this.options);
	}

	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	updateURL() {
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	renderVariantInfo(html) {
		this.updateElementOuter('#product_id', html);
		this.updateElementOuter('.mm-big-wrapper-btn', html);
		this.updateElementOuter('.mm-variant-cta-mobile', html);
		this.updateElementOuter('.mm-update-price', html);
		this.updateElementOuter('.mm-product-form-variant-color', html);
	}

	updateCTA() {
		const stickyCTA = document.querySelector('.mm-wrapper-update-price');
        if(stickyCTA) {
    		stickyCTA.querySelector('.mm-update-price').innerText = `${this.currentVariant.price / 100} €`;

    		if (this.currentVariant.available) {
    			stickyCTA.classList.remove('mm-btn-disabled');
    		} else {
    			stickyCTA.classList.add('mm-btn-disabled');
    		}
        }
	}

	/**
	 *
	 * @param {string} selector
	 * @param {HtmlElement} html
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	updateElementOuter(selector, html) {
    	const destinations = this.container.querySelectorAll(selector);
    	const sources = html.querySelectorAll(selector);

    	if (sources.length !== destinations.length) {
    		console.warn(`The number of source elements (${sources.length}) does not match the number of destination elements (${destinations.length}) for the selector "${selector}".`);
    		return;
    	}

    	destinations.forEach((destination, index) => {
    		const source = sources[index];
    		if (source && destination) {
    			// Vérifiez si l'élément à mettre à jour est le CTA
    			if (selector === '.mm-cta-sticky') {
    				destination.innerHTML = source.innerHTML;
    				destination.classList.add('mm-cta-sticky');
    			} else {
    				destination.outerHTML = source.outerHTML;
    			}
    		}
    	});
    }

}
customElements.define('variant-selector', VariantSelector);


// SELECT THE RIGHT VARIANT SIZE ON COLOR CHANGE

document.addEventListener('DOMContentLoaded', function() {
  // Fonction pour initialiser max_size_selector à partir de longueur si nécessaire
    function initializeMaxSizeFromLength() {
        const maxSize = localStorage.getItem('max_size_selector');

        if (maxSize === null) { // Vérifie si max_size_selector n'existe pas
            const longueur = localStorage.getItem('longueur');
            if (longueur !== null) { // Vérifie si longueur existe
                localStorage.setItem('max_size_selector', longueur);
            }
        }
    }

    // Fonction pour écouter les changements sur les sélecteurs de variante
    function listenToVariantSelectors() {
        const variantSelectors = document.querySelectorAll('.mm-variant-select-selector');

        variantSelectors.forEach(selector => {
            selector.addEventListener('change', function(event) {
                const selectedOption = event.target.options[event.target.selectedIndex];
                const value = selectedOption.text;
                const regex = /[A-Za-z0-9]+\s\(\d+\.\d+cm\s-\s(\d+\.\d+)cm\)/;
                const match = value.match(regex);

              console.log('parseFloat(match[1])', parseFloat(match[1]))

                if (match) {
                    const maxSize = parseFloat(selectedOption.dataset.finProposition);
                    localStorage.setItem('max_size_selector', maxSize);
                }
            });
        });
    }

    // Fonction pour sélectionner la bonne option au chargement de la page
    function selectOptionBasedOnLocalStorage() {
    const maxSize = parseFloat(localStorage.getItem('max_size_selector'));

        if (!isNaN(maxSize)) {
            const variantSelectors = document.querySelectorAll('.mm-variant-select-selector');

            variantSelectors.forEach(selector => {
                const options = selector.options;

                for (let i = 0; i < options.length; i++) {
                    const value = options[i].text;
                    const regex = /[A-Za-z0-9]+\s\(\d+\.\d+cm\s-\s(\d+\.\d+)cm\)/;
                    const match = value.match(regex);

                    if (match) {
                        const minValue = parseFloat(options[i].dataset.debutPointure);
                        const maxValue = parseFloat(options[i].dataset.finProposition);

                        console.log('minValue', minValue)
                        console.log('maxValue', maxValue)

                        if (maxSize >= minValue && maxSize <= maxValue) {
                            selector.selectedIndex = i;
                            const event = new Event("change");
                            document.querySelector('variant-selector').dispatchEvent(event);
                            break;
                        }

                        if (maxSize < minValue && maxSize < maxValue) {
                            selector.selectedIndex = i;
                            const event = new Event("change");
                            document.querySelector('variant-selector').dispatchEvent(event);
                            break;
                        }
                    }
                }
            });
        }
    }

    // Initialiser max_size_selector à partir de longueur si nécessaire
    initializeMaxSizeFromLength();

    // Initialiser l'écoute des sélecteurs de variante
    listenToVariantSelectors();

    // Sélectionner l'option appropriée au chargement de la page
    selectOptionBasedOnLocalStorage();
});

const giftFormContainer = document.getElementById('mm-product-gift-form')
const giftCheckbox = giftFormContainer.querySelector('#gift-checkbox');
const giftForm = giftFormContainer.querySelector('.mm-gift-info-form')

function toggleGiftForm() {
  if (giftCheckbox.checked) {
    giftForm.classList.remove('hidden'); // Remplacez 'hidden-class' par le nom de votre classe
  } else {
    giftForm.classList.add('hidden'); // Remplacez 'hidden-class' par le nom de votre classe
  }
}

giftCheckbox.addEventListener('change', toggleGiftForm);
